<input type="file" #imgGet id="imgGet" name="imgGet" style="display:none;" />
<div class="cardImg">
  <span *ngIf="metadata.img.name == ''">Agregar archivo.</span>
  <span *ngIf="metadata.img.name != ''">{{metadata.img.name}}</span>
  <button mat-raised-button color="primary" class="cardImgButtom" (click)="loadImg();" *ngIf="metadata.img.name == '' && !metadata.uploadted">Seleccionar</button>
  <button mat-raised-button color="primary" class="cardImgButtom" (click)="uploadImg();" *ngIf="metadata.img.name != '' && !metadata.uploadted">Subir</button>
  <span class="material-icons cardImgIcon" style="cursor:pointer;" *ngIf="metadata.uploadted" (click)="deleteImg();">delete</span>
  <span class="material-icons cardImgIcon" *ngIf="metadata.uploadted">verified</span>
</div>
